// extracted by mini-css-extract-plugin
module.exports = {"actions":"pages-campaign-emailBodyEditor__actions--2EE6B"};